var AkrisUpdateUserRequest = /** @class */ (function () {
    function AkrisUpdateUserRequest() {
        this.fullName = "";
        this.firstName = "";
        this.lastName = "";
        this.middleName = "";
        this.title = "";
        this.suffix = "";
        this.phoneNumber = "";
        this.emailAddress = "";
    }
    AkrisUpdateUserRequest.prototype.toRequestObject = function () {
        return {
            FullName: this.fullName,
            FirstName: this.firstName,
            LastName: this.lastName,
            MiddleName: this.middleName,
            Title: this.title,
            Suffix: this.suffix,
            PhoneNumber: this.phoneNumber,
            EmailAddress: this.emailAddress
        };
    };
    return AkrisUpdateUserRequest;
}());
export default AkrisUpdateUserRequest;
//# sourceMappingURL=akrisUpdateUserRequest.js.map